<script>
/* eslint-disable */
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import { nextTick } from 'vue';
import jQuery from 'jquery';
import testdrive from '@/components/testdrive/index.vue';
import popup_sucess from '@/components/popup_sucess/index.vue';
import reserve from '@/components/reserve/index.vue';
import axios from 'axios';
window.$ = window.jQuery = jQuery;
export default {
	name: 'info',
	props: {
		isActiveRule: {
			type: Boolean,
			required: true,
		},
		isActiveList: {
			type: Boolean,
			required: true,
		},
		prePage: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			isActiveSlider: false,
			isActiveTestdrive: false,
			isActiveReserve: false,
			isActiveSucess: false,
			isActiveListFromReserve: false,
			isActiveRuleFromReserve: false,
			isActiveRuleFromForm: false,
			isActiveSucessfromForm: false,
			isActiveSucessfromPop: false,
			isActiveShare: false,
			popupTitle: '預約賞車',
			reserveStatus: 'form', //'form' or 'preview'
			testdrive_use_info: false,
			reserve_use_info: false,
			reserve_list: false,
			popPicSlickOptions: {
				arrows: true,
				infinite: true,
				dots: true,
				fade: true,
			},
			carId: '',
			carData: {},
			shareURL: '',
		};
	},
	components: {
		Slick,
		nextTick,
		jQuery,
		testdrive,
		popup_sucess,
		reserve,
	},
	computed: {
		hostUrl() {
			return this.$store.state.hostUrl;
		},
		collectionIdArr() {
			return this.$store.state.collectionIdArr;
		},
		collectionInfoArr() {
			return this.$store.state.collectionInfoArr;
		},
		comparisonIdArr() {
			return this.$store.state.comparisonIdArr;
		},
		comparisonInfoArr() {
			return this.$store.state.comparisonInfoArr;
		},
	},
	watch: {
		isActiveListFromReserve: function (newV) {
			// console.log("isActiveListFromReserve")
			let vm = this;
			if (newV) {
				vm.$emit('update:isActiveList', true);
				vm.isActiveListFromReserve = false;
				setTimeout(() => {
					vm.reserve_list = true;
				}, 1000);
			}
		},
		isActiveRuleFromReserve: function (newV) {
			// console.log("isActiveRuleFromReserve")
			let vm = this;
			if (newV) {
				vm.$emit('update:isActiveRule', true);
				vm.isActiveRuleFromReserve = false;
				setTimeout(() => {
					vm.reserve_use_info = true;
				}, 1000);
			}
		},
		isActiveRuleFromForm: function (newV) {
			// console.log("isActiveRuleFromForm")
			let vm = this;
			if (newV) {
				vm.$emit('update:isActiveRule', true);
				vm.isActiveRuleFromForm = false;
				setTimeout(() => {
					vm.testdrive_use_info = true;
				}, 1000);
			}
		},
		isActiveSucessfromForm: function (newV) {
			// console.log("isActiveSucessfromForm")
			let vm = this;
			if (newV) {
				vm.isActiveSucess = true;
				vm.isActiveSucessfromForm = false;
			}
		},
		isActiveSucessfromPop: function (newV) {
			let vm = this;
			if (newV) {
				vm.isActiveSucess = false;
				vm.isActiveSucessfromPop = false;
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		this.$emit('update:isActiveLoading', true);
		let vm = this;
		if (from.name === 'Info' && to.name == 'Search') {
			vm.$gtag.event('CLICK', {
				event_category: 'click',
				event_label: `Click_${vm.carData.car.no}_back`,
				send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
			});
		}
		next();
	},
	mounted() {
		let vm = this;
		vm.$nextTick(function () {
			if (vm.$route.params.id) {
				vm.carId = vm.$route.params.id;
				vm.getData();
			}
		});
	},
	methods: {
		picAfterChange() {
			// console.log("picAfterChange")
			let vm = this;
			vm.$gtag.event('CLICK', {
				event_category: 'click',
				event_label: `Click_${vm.carData.car.no}_pic_slide`,
				send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
			});
		},
		gtag(target) {
			let vm = this;
			switch (target) {
				case 'Manual':
					vm.$gtag.event('CLICK', {
						event_category: 'click',
						event_label: `Click_${vm.carData.car.no}_Manual`,
						send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
					});
					break;
				case 'video':
					vm.$gtag.event('CLICK', {
						event_category: 'click',
						event_label: `Click_${vm.carData.car.no}_video`,
						send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
					});
					break;
			}
		},
		updateComparison(id) {
			// console.log("updateComparison",id)
			let vm = this;
			if (vm.comparisonIdArr.indexOf(id) == -1) {
				let element = vm.carData.car;
				vm.$store.dispatch('GETCOMPARISON', { id, element });
				vm.$gtag.event('CLICK', {
					event_category: 'click',
					event_label: `Click_${vm.carData.car.no}_compare`,
					send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
				});
			} else {
				vm.comparisonInfoArr.forEach((element, index) => {
					if (element.id === id) {
						vm.$store.dispatch('GETCOMPARISON', { id, element });
					}
				});
			}
		},
		updateCollection(id) {
			// console.log("updateCollection")
			let vm = this;
			if (vm.collectionIdArr.indexOf(id) == -1) {
				let element = vm.carData.car;
				vm.$store.dispatch('GETCOLLECTION', { id, element });
				vm.$gtag.event('CLICK', {
					event_category: 'click',
					event_label: `Click_${vm.carData.car.no}_save`,
					send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
				});
			} else {
				vm.collectionInfoArr.forEach((element, index) => {
					if (element.id === id) {
						vm.$store.dispatch('GETCOLLECTION', { id, element });
						vm.$gtag.event('CLICK', {
							event_category: 'click',
							event_label: `Click_${vm.carData.car.no}_remove`,
							send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
						});
					}
				});
			}
		},
		getData() {
			// console.log('getData');
			let vm = this;
			axios
				.post(vm.hostUrl + '/api/car/' + vm.carId)
				.then(function (response) {
					if (response.data.car === null) {
						vm.$router.replace('/');
					} else {
						vm.carData = response.data;
						setTimeout(() => {
							vm.$emit('update:isActiveLoading', false);
						}, 1000);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		addCount(str) {
			// console.log("addCount", str);
			str = parseInt(str) * 58;
			return str.toLocaleString();
		},
		changeToLocaleString(str) {
			// console.log("changeToLocaleString", str);
			str = parseInt(str);
			return str.toLocaleString();
		},
		sliderToggle(target) {
			// console.log("sliderToggle",target)
			let vm = this;
			vm.isActiveSlider = !vm.isActiveSlider;
			vm.$gtag.event('CLICK', {
				event_category: 'click',
				event_label: `Click_${vm.carData.car.no}_pic`,
				send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
			});
			if (vm.isActiveSlider) {
				setTimeout(() => {
					$('.pic-slider').slick('slickGoTo', target);
				}, 150);
			}
		},
		strChange(str) {
			return str.replace(/\r\n/g, '<br>');
		},
		testdriveToggle() {
			// console.log("testdriveToggle","info")
			let vm = this;
			vm.isActiveTestdrive = !vm.isActiveTestdrive;
			vm.$gtag.event('CLICK', {
				event_category: 'click',
				event_label: `Click_${vm.carData.car.no}_testdrive`,
				send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
			});
			vm.$gtag.pageview({
				page_path: '/info',
				page_title: `PV_${vm.carData.car.no}_testdrive`,
			});
			fbq('trackSingle', '436643020262829', 'Contact');
			fbq('trackSingle', '2320616348184878', 'Contact');
			_lt(
				'send',
				'cv',
				{
					type: 'TourCar',
				},
				['f318243c-e326-4eae-ab95-2a016ce79687'],
			);
		},
		reserveToggle() {
			// console.log("reserveToggle", "info");
			let vm = this;
			vm.isActiveReserve = !vm.isActiveReserve;

			vm.$gtag.event('CLICK', {
				event_category: 'click',
				event_label: `Click_${vm.carData.car.no}_order`,
				send_to: ['UA-124821034-1', 'G-CYXF981YFQ'],
			});
			vm.$gtag.pageview({
				page_path: '/info',
				page_title: `PV_${vm.carData.car.no}_order`,
			});

			fbq('trackSingle', '165840282383651', 'InitiateCheckout');
			_lt(
				'send',
				'cv',
				{
					type: 'ReserveNow',
				},
				['f318243c-e326-4eae-ab95-2a016ce79687'],
			);
		},
		shareEvent(type) {
			// console.log('shareEvent', type);
			let vm = this;

			vm.shareURL = `${location.origin}/info/${vm.carId}`;
			switch (type) {
				case 'fb':
					window.fbAsyncInit = function () {
						FB.init({
							appId: '3828659104039091',
							cookie: true,
							xfbml: true,
							version: 'v21.0',
						});
					};
					FB.ui(
						{
							method: 'share',
							href: vm.shareURL,
						},
						function (response) {
							if (response && !response.error_message) {
								console.log('分享成功', response);
							} else {
								console.log('分享失敗或使用者取消', response);
							}
						},
					);
					break;
				case 'line':
					window.open(`https://social-plugins.line.me/lineit/share?url=${vm.shareURL}`);
					break;
				case 'copylink':
					navigator.clipboard.writeText(vm.shareURL);
					setTimeout(() => {
						alert('已複製至剪貼簿');
					}, 500);
					break;
			}
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
